import { type ReactElement, type ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SettingsTabBar } from './SettingsTabBar';
import { normalizeTabKey, type TabKeyFor } from './settingsTabs';
import { type SettingsContext } from './config/settingsContext';
import { SettingsUnsavedChangesProvider } from './SettingsUnsavedChangesGuard';

type Props<C extends SettingsContext> = {
  context: C;
  hiddenTabs?: readonly TabKeyFor<C>[];
  children?: ReactNode;
};

export function SettingsPageLayout<C extends SettingsContext>({
  context,
  hiddenTabs,
  children,
}: Props<C>): ReactElement {
  const [searchParams] = useSearchParams();
  const activeTab: TabKeyFor<C> = normalizeTabKey(
    context,
    searchParams.get('tab')
  );

  return (
    <SettingsUnsavedChangesProvider>
      <div className="max-w-[900px]">
        <SettingsTabBar context={context} hiddenTabs={hiddenTabs} />
        {children ?? (
          <div
            id={`settings-panel-${activeTab}`}
            role="tabpanel"
            aria-labelledby={`settings-tab-${activeTab}`}
            data-tab={activeTab}
            className="mt-8"
          />
        )}
      </div>
    </SettingsUnsavedChangesProvider>
  );
}
